//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "LoadingComponent",
  model: {
    prop: "show",
    event: "updateShow",
  },
  props: {
    // 是否显示已做v-model
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showModal: this.show,
    };
  },
  watch: {
    showModal(val) {
      this.$emit("updateShow", val);
    },
    show(val) {
      this.showModal = val;
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/toast/Loading.vue